"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = global.Decimal || require("decimal.js");
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9kZWNpbWFsLmpzIl0sIm5hbWVzIjpbImdsb2JhbCIsIkRlY2ltYWwiLCJyZXF1aXJlIl0sIm1hcHBpbmdzIjoiOzs7OztrQkFBZUEsT0FBT0MsT0FBUCxJQUFrQkMsUUFBUSxZQUFSLEMiLCJmaWxlIjoiZGVjaW1hbC5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGdsb2JhbC5EZWNpbWFsIHx8IHJlcXVpcmUoXCJkZWNpbWFsLmpzXCIpXG4iXX0=


//////////////////
// WEBPACK FOOTER
// ../growth/lib/decimal.js
// module id = 370
// module chunks = 0